import React from 'react';
import CadFileSpec from './CadFileSpec';
import OtherFileSpec from './OtherFileSpec';

function MeasurementsExpandView({ index, data, libName, subBrandAccess }) {
  const totalLibs = {
    totalCadFileLib: data.measurementLibaries[0].pomLibraries.length,
    totalOtherSpecLib: data.measurementLibaries[0].specPomLibraries.length,
  };

  return (
    <>
      <CadFileSpec subBrandAccess={subBrandAccess} index={index} data={data} totalLibs={totalLibs} cadFileSpec={data.measurementLibaries[0].pomLibraries} />

      <OtherFileSpec
        subBrandAccess={subBrandAccess}
        index={index}
        data={data}
        totalLibs={totalLibs}
        otherFileSpec={data.measurementLibaries[0].specPomLibraries}
      />
    </>
  );
}

// measurementLibaries, pomLibraries, specPomLibraries
export default MeasurementsExpandView;
